import { PntsBatchTable, PntsFeatureTable } from '../../../../loader/cesium/content/pnts/types';

export const getFeatureAttributeName = (feature: keyof PntsFeatureTable | keyof PntsBatchTable) => {
  switch (feature) {
    case 'POSITION':
      return 'position';
    case 'RGB':
    case 'RGBA':
      return 'color';
    case 'NORMAL':
      return 'normal';
    case 'Classification':
      return 'classification';
    default:
      throw new Error(`Unsupported feature: ${feature}`);
  }
};
